import { NgIf } from '@angular/common';
import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { ButtonModule } from '@coreui/angular-pro';
@Component({
  selector: 'app-edit-modal',
  standalone: true,
  imports: [NgIf, MatDialogModule, ButtonModule],
  templateUrl: './edit-modal.component.html',
  styleUrls: ['./edit-modal.component.scss']
})
export class EditModalComponent {
  constructor(public dialogRef: MatDialogRef<EditModalComponent>) { }
}
